<template>
	<form @submit.prevent="doUpdate()" @keyup.enter="doUpdate()" class="flex flex-col lg:grid lg:grid-cols-2 lg:col-span-2 gap-3 w-full">
		<!-- TARGETED objective -->
		<span class="flex justify-between gap-2 items-center col-span-2">
			Cibler le contact ? :
			<ui-toggle v-model="form.targeted" :icons="['fa-crosshairs', 'fa-crosshairs']" />
		</span>
		<!-- CIBLE -->
		<form-select
			:items="page.props.str.statuses.filter((status) => status.type == 'target')"
			placeholder="Cible"
			@valueChange="form.target = $event"
			:value="form.target?.id ? form.target?.id : form.target"
			class="col-span-2">
		</form-select>
		<!-- STATUS -->
		<form-select
			:items="page.props.str.statuses.filter((status) => status.type == 'progress')"
			placeholder="Status"
			@valueChange="form.status = $event"
			:value="form.status?.id ? form.status?.id : form.status"
			class="col-span-2">
		</form-select>
		<!-- TYPE -->
		<form-select
			:items="page.props.str.statuses.filter((status) => status.type == 'structure')"
			placeholder="Type *"
			@valueChange="form.type = $event"
			:value="form.type?.id ? form.type?.id : form.type"
			class="col-span-2">
		</form-select>
		<!-- NAME-->
		<form-input v-model="form.name" placeholder="Nom" class="lg:col-span-2"> </form-input>
		<!-- ADDRESS -->
		<form-input placeholder="Adresse" v-model="form.address" class="lg:col-span-2"> </form-input>
		<!-- CITY + POSTAL CODE -->
		<form-input v-model="form.postal_code" placeholder="Code Postal"> </form-input>
		<form-input v-model="form.city" placeholder="Ville"> </form-input>
		<!-- PHONE + EMAIL -->
		<form-input v-model="form.phone" placeholder="Téléphone"> </form-input>
		<form-input v-model="form.email" placeholder="E-Mail"> </form-input>
		<!-- PRO_ID -->
		<form-input placeholder="Numéro professionnel (FINESS)" v-model="form.pro_id" class="lg:col-span-2"> </form-input>
		<h2 class="lg:col-span-2 font-medium">Informations complémentaires</h2>
		<!-- COMMENT -->
		<form-textarea :placeholder="'Commentaire'" v-model="form.comment" class="col-span-2"> </form-textarea>
		<ui-button @click="doUpdate" :loading="formLoading" class="col-span-2 mt-3 font-bold border-2">
			<template v-slot:icon><i class="fas fa-edit"></i></template>
			<template v-slot:text>Valider les modifications</template>
		</ui-button>
	</form>
</template>

<script setup>
	import { ref, onMounted } from 'vue';
	import { usePage, useForm, router } from '@inertiajs/vue3';
	import { toast } from 'vue3-toastify';

	const page = usePage();

	const props = defineProps({
		structure: {
			type: Object,
			required: true,
			default: () => ({}),
		},
	});

	const emit = defineEmits(['toggle']);

	const formLoading = ref(false);

	const form = useForm({
		targeted: false,
		name: '',
		target: null,
		type: null,
		email: '',
		phone: '',
		address: '',
		postal_code: '',
		city: '',
		pro_id: '',
		comment: '',
		status: null,
	});

	const getStructureInfo = () => {
		form.targeted = props.structure.targeted;
		form.name = props.structure.name;
		form.target = props.structure.target?.id || props.structure.target;
		form.type = props.structure.type?.id || props.structure.type;
		form.email = props.structure.email;
		form.phone = props.structure.phone;
		form.address = props.structure.address;
		form.postal_code = props.structure.postal_code;
		form.city = props.structure.city;
		form.pro_id = props.structure.pro_id;
		form.comment = props.structure.comment;
		form.status = props.structure.status?.id || props.structure.status;
	};

	const doUpdate = () => {
		toast.info('Structure en cours de modification');
		formLoading.value = true;

		form.post(route('structures.update', props.structure.id), {
			preserveScroll: true,
			onSuccess: () => {
				toast.success('Structure modifiée avec succès !');
				getStructureInfo();
			},
			onError: () => {
				toast.error("Une erreur s'est produite");
				getStructureInfo();
			},
			onFinish: () => {
				emit('toggle');
				formLoading.value = false;
			},
		});
	};
	defineExpose({
		doUpdate,
	});

	onMounted(() => {
		getStructureInfo();
	});
</script>
